<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import { authAppOne, authAppTwo, authAppThree } from "@/api/permissions.js";
export default {
  data() {
    return {
      isActive: 0,
      currentRow: {},
      testdata: "",
    };
  },
  components: {
    CertifiedHosp: () => import("./components/page.vue"),
    TheApproved: () => import("./components/Setpermi.vue"),
    // TheEditor: () => import("./components/HeExamines.vue"),
    // Encryption: () => import("./components/encryption/setEncryption.vue"),
    // DecryTable: () => import("./components/encryption/decryTable.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "TheApproved";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (index == "0" && this.isActive == "1") {
        this.$children[0].Buriedpoint({
          code: "Webmaster:Personnel:permissions",
          parent_code: "Webmaster:Personnel",
        });
      }
      this.isActive = index;
    },
  },
  created() {},
};
</script>